import { render, staticRenderFns } from "./TableFooterButtons.vue?vue&type=template&id=295a0b15&"
import script from "./TableFooterButtons.vue?vue&type=script&lang=ts&"
export * from "./TableFooterButtons.vue?vue&type=script&lang=ts&"
import style0 from "./TableFooterButtons.vue?vue&type=style&index=0&id=295a0b15&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports